import { apiService } from './api';

export interface KnowledgeExportCounts {
  stakeholders: number;
  organizations: number;
  wikiPages: number;
  assignments: number;
  relationships: number;
  influenceScores: number;
  news: number;
  mediaFiles: number;
  categories: number;
}

export interface KnowledgeExportSummary {
  counts: KnowledgeExportCounts;
  media: { files: number; bytes: number };
  estimatedBytes: { withMedia: number; withoutMedia: number };
  generatedAt: string;
}

export interface KnowledgeExportOptions {
  includeMedia: boolean;
  includeData: boolean;
}

export const knowledgeExportService = {
  async getSummary(): Promise<KnowledgeExportSummary> {
    const response = await apiService.get('/api/export/summary');
    return response.data;
  },

  async download(options: KnowledgeExportOptions): Promise<Blob> {
    const params = new URLSearchParams({
      media: String(options.includeMedia),
      data: String(options.includeData),
    });
    const response = await apiService.get(`/api/export/knowledge-base?${params.toString()}`, {
      responseType: 'blob',
      // A large export with media takes a while to stream
      timeout: 15 * 60 * 1000,
    });
    return response.data;
  },
};
